<template>
    <el-dialog
        title="所属供应商"
        class="ps-belong-supplier-dialog"
        width="780px"
        :visible.sync="visible"
        :before-close="close"
    >
        <el-table :data="tableData" :max-height="341" border>
            <el-table-column prop="supplierName" label="供应商名称"></el-table-column>
            <el-table-column prop="supplierCode" label="供应商编码"></el-table-column>
            <el-table-column prop="supplierStatus_" label="供应商状态"></el-table-column>
            <el-table-column prop="businessTypeStatus_" label="业务类型状态"></el-table-column>
            <el-table-column prop="businessType_" label="业务类型"></el-table-column>
            <el-table-column prop="corporateType_" label="合作方式"></el-table-column>
        </el-table>
        <m-page :currentPage="page.currentPage" :pageData="page.pageData" :total="page.total" @on-size-change="handleSizeChange" @on-page-change="handlePageChange"></m-page>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">关 闭</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api'
import { querySupplierInfo } from '../../../../../api/physicalStorage.js'
import MPage from '@/components/supplierPanel/mPage';

const dictNameArr = ['SYS_SUPPLIERS_STATUS', 'SYS_SUPPLIER_SERVICES_STATUS', 'SRM_BUSYNESS_TYPE_BACKGROUND', 'SU_CORPORATE_TYPE']

export default {
    components: { MPage },
    props: {
        // tableData: {
        //     type: Array,
        //     default() {
        //         return [];
        //     }
        // }
    },
    data() {
        return {
            whCode: null,
            visible: false,
            loading: true,
            dictData: {},
            tableData: [],
            page: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                pageData: {
                    pageSize: 10,
                    pageSizes: [10]
                }
            },
        };
    },
    methods: {
        async open(row) {
            this.whCode = row.whCode
            this.visible = true;
            if (dictNameArr.some(item => !this.dictData[item])) {
                this.loading = true
                const res = await dictWithUrl(dictNameArr.join(',')).catch(err => {});
                this.loading = false
                if (!res || +res.code !== 0) {
                    return false
                }
                this.dictData = res.data
            }
            this.loadData()
        },
        close() {
            this.whCode = null
            this.tableData = [];
            this.page.currentPage = 1;
            this.visible = false;
        },
        handleSizeChange(val) {
            this.page.pageSize = val;
            this.loadData();
        },
        handlePageChange(val) {
            this.page.currentPage = val;
            this.loadData();
        },
        loadData() {
            this.loading = true;
            const params = {
                pageNo: this.page.currentPage,
                pageSize: this.page.pageSize,
                whCode: this.whCode
            }
            querySupplierInfo(params).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list.map(item => {
                        return {
                            ...item,
                            supplierStatus_: this.dictData['SYS_SUPPLIERS_STATUS'][item.supplierStatus],
                            businessTypeStatus_: this.dictData['SYS_SUPPLIER_SERVICES_STATUS'][item.businessTypeStatus],
                            businessType_: this.dictData['SRM_BUSYNESS_TYPE_BACKGROUND'][item.businessType],
                            corporateType_: this.dictData['SU_CORPORATE_TYPE'][item.corporateType]
                        }
                    });
                    this.page.total = res.data.totalCount;
                }
            }).finally(() => { this.loading = false; })
        },
    }
};
</script>
<style lang="less">
.ps-belong-supplier-dialog .el-dialog__body {
    overflow: hidden;

    .el-table {
        margin-bottom: 10px;
    }
}
</style>